function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShipito(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 40 40",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#666666",
    d: "M 14.5,0.5 C 14.5,0.166667 14.5,-0.166667 14.5,-0.5C 17.1667,-0.5 19.8333,-0.5 22.5,-0.5C 22.2934,2.74539 23.7934,4.74539 27,5.5C 27.9525,3.40783 29.2859,3.0745 31,4.5C 31.5074,5.99608 31.0074,7.16274 29.5,8C 31.229,9.7889 31.8957,11.9556 31.5,14.5C 30.2819,18.3828 27.9485,21.3828 24.5,23.5C 23.8333,23.5 23.5,23.1667 23.5,22.5C 25.6801,20.9687 26.6801,18.8021 26.5,16C 26.6068,13.7794 25.9402,11.9461 24.5,10.5C 22.3155,8.4152 19.6489,7.4152 16.5,7.5C 16.4606,6.41683 16.1272,5.41683 15.5,4.5C 16.0253,3.80762 16.6919,3.30762 17.5,3C 16.3094,2.30206 15.3094,1.46872 14.5,0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f9fd",
    d: "M 16.5,7.5 C 19.6489,7.4152 22.3155,8.4152 24.5,10.5C 25.9402,11.9461 26.6068,13.7794 26.5,16C 26.6801,18.8021 25.6801,20.9687 23.5,22.5C 14.3963,25.2244 10.2296,21.8911 11,12.5C 12.7297,10.5981 14.563,8.93142 16.5,7.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#666666",
    d: "M 24.5,10.5 C 23.0258,14.3142 20.3591,16.6475 16.5,17.5C 16.7035,15.6096 16.0368,14.1096 14.5,13C 16.0468,12.6666 17.3801,13.1666 18.5,14.5C 20.264,12.7224 22.264,11.3891 24.5,10.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#666666",
    d: "M 14.5,0.5 C 15.3094,1.46872 16.3094,2.30206 17.5,3C 16.6919,3.30762 16.0253,3.80762 15.5,4.5C 16.1272,5.41683 16.4606,6.41683 16.5,7.5C 14.563,8.93142 12.7297,10.5981 11,12.5C 10.2296,21.8911 14.3963,25.2244 23.5,22.5C 23.5,23.1667 23.8333,23.5 24.5,23.5C 20.4439,26.626 15.7772,27.9593 10.5,27.5C 4.134,21.8351 3.134,15.3351 7.5,8C 4.7019,5.9336 5.03523,4.4336 8.5,3.5C 11.8882,5.13942 13.8882,4.13942 14.5,0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#666666",
    d: "M 31.5,14.5 C 32.6129,15.9464 32.7796,17.6131 32,19.5C 30.8201,21.8599 29.6534,24.1932 28.5,26.5C 27.1667,26.5 25.8333,26.5 24.5,26.5C 21.3033,28.8029 20.6367,31.8029 22.5,35.5C 21.5,35.8333 20.8333,36.5 20.5,37.5C 19.1667,37.5 17.8333,37.5 16.5,37.5C 14.0751,34.4114 12.0751,31.0781 10.5,27.5C 15.7772,27.9593 20.4439,26.626 24.5,23.5C 27.9485,21.3828 30.2819,18.3828 31.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 26.5,28.5 C 26.7822,29.7777 27.4489,30.7777 28.5,31.5C 27.2502,31.5774 26.4169,32.244 26,33.5C 25.5,32.3333 24.6667,31.5 23.5,31C 24.6906,30.3021 25.6906,29.4687 26.5,28.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.963
    },
    fill: "#666666",
    d: "M 24.5,26.5 C 25.8333,26.5 27.1667,26.5 28.5,26.5C 31.8618,28.8823 32.1951,31.549 29.5,34.5C 27.5188,33.8946 27.1854,32.8946 28.5,31.5C 27.4489,30.7777 26.7822,29.7777 26.5,28.5C 25.8333,27.8333 25.1667,27.1667 24.5,26.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#666666",
    d: "M 24.5,26.5 C 25.1667,27.1667 25.8333,27.8333 26.5,28.5C 25.6906,29.4687 24.6906,30.3021 23.5,31C 24.6667,31.5 25.5,32.3333 26,33.5C 26.4169,32.244 27.2502,31.5774 28.5,31.5C 27.1854,32.8946 27.5188,33.8946 29.5,34.5C 27.5055,36.7107 25.1721,37.0441 22.5,35.5C 20.6367,31.8029 21.3033,28.8029 24.5,26.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipito);
export default __webpack_public_path__ + "static/media/shipito.86b76683a549259c95593c7c37e89a34.svg";
export { ForwardRef as ReactComponent };